import Reflux from 'reflux';

const IndicesConfigurationActions = Reflux.createActions({
  'loadRotationConfig': {asyncResult: true},
  'loadRotationStrategies': {asyncResult: true},
  'loadRetentionConfig': {asyncResult: true},
  'loadRetentionStrategies': {asyncResult: true},
  'updateRotationConfiguration': {asyncResult: true},
  'updateRetentionConfiguration': {asyncResult: true},
});

export default IndicesConfigurationActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/indices/IndicesConfigurationActions.js